import React, { FC, PropsWithChildren } from 'react';
import { AuthContext, UsuarioContext, MenusContext, useAuthContext } from '@/context';
import { useAuth, useUsuario, useMenus } from '@/hooks';

export const AppContext: FC<PropsWithChildren> = ({ children }) => {
  const auth = useAuth();
  const [empresaId, setEmpresaId] = React.useState<string | null>(null);

  React.useEffect(() => {
    setEmpresaId(localStorage.getItem('cID'));
  }, []);

  return (
    <AuthContext.Provider value={auth}>
      <EmpresaContext.Provider value={empresaId}>
        <SignedInContext>{children}</SignedInContext>
      </EmpresaContext.Provider>
    </AuthContext.Provider>
  );
};

const SignedInContext: FC<PropsWithChildren> = ({ children }) => {
  const auth = useAuthContext();
  const empresaId = useEmpresa();
  const usuario = useUsuario(Boolean(auth.isSignedIn), empresaId);
  const menus = useMenus(Boolean(auth.isSignedIn));

  return (
    <UsuarioContext.Provider value={usuario}>
      <MenusContext.Provider value={menus}>{children}</MenusContext.Provider>
    </UsuarioContext.Provider>
  );
};

export const EmpresaContext = React.createContext<string | null>(null);
export const useEmpresa = () => React.useContext(EmpresaContext);
